import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'cookie_consent_v1';

const updateGtagConsent = (analytics, marketing) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (analytics, marketing) => {
    const value = { analytics, marketing, decided_at: new Date().toISOString() };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch { /* ignore */ }
    updateGtagConsent(analytics, marketing);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[9000] px-3 sm:px-6 pb-3 sm:pb-6"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
    >
      <div className="mx-auto max-w-[1100px] panel border border-border bg-background/95 backdrop-blur-md shadow-2xl">
        <div className="p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-5">
          <div className="flex items-start gap-3 flex-1">
            <span className="w-10 h-10 grid place-items-center rounded-full bg-teal-400 text-black shrink-0">
              <Cookie size={18} strokeWidth={1.5} />
            </span>
            <div className="text-sm leading-relaxed">
              <div className="label-mono mb-1">We use cookies</div>
              <p className="text-foreground/90">
                PackCheck uses essential cookies to keep you signed in, and optional analytics cookies
                (Google Analytics) to understand how the product is used. We never sell your data.
                Read our <Link to="/privacy" className="underline hover:text-foreground">Privacy Policy</Link>.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap md:flex-nowrap md:justify-end shrink-0">
            <button
              onClick={() => persist(false, false)}
              data-testid="cookie-decline"
              className="h-10 px-4 border border-border hover:bg-surface-hover transition-colors text-sm whitespace-nowrap"
            >
              Decline
            </button>
            <button
              onClick={() => persist(true, false)}
              data-testid="cookie-accept"
              className="h-10 px-5 bg-foreground text-background hover:opacity-90 transition-opacity text-sm font-medium whitespace-nowrap"
            >
              Accept
            </button>
            <button
              onClick={() => persist(false, false)}
              aria-label="Dismiss"
              data-testid="cookie-close"
              className="hidden md:grid w-10 h-10 place-items-center border border-border hover:bg-surface-hover"
            >
              <X size={14} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
